<template>
  <el-dialog
    :title="model.id > 0 ? '编辑人员' : '添加人员'"
    :visible.sync="visible"
    label-width="100px"
    width="40%"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="100px"
      size="small"
    >
      <el-form-item label="英文名" prop="name">
        <el-input v-model="model.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="中文名" prop="name_en">
        <el-input v-model="model.name_en" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone_number">
        <el-input
          v-model="model.phone_number"
          autocomplete="off"
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="model.email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="roles">
        <el-select
          style="width: 100%"
          v-model="model.roles"
          multiple
          placeholder="请选择职位"
        >
          <el-option
            v-for="item in roles"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="C4C ID" prop="c4c_id">
        <el-input v-model="model.c4c_id" autocomplete="off"></el-input>
      </el-form-item>
      <!-- <el-form-item label="简称" prop="contraction">
        <template slot="label">简称<CustomTip :t="2"></CustomTip></template>
        <el-input v-model="model.contraction" autocomplete="off"></el-input>
      </el-form-item> -->
      <el-form-item label="区域" prop="area_id" v-if="auth.isPlatformUser()">
        <el-select
          style="width: 100%"
          v-model="model.area_id"
          placeholder="请选择区域"
          clearable
        >
          <el-option
            v-for="(value, index) in AreaTextMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市" v-if="auth.isPlatformUser()">
        <el-cascader
          style="width: 100%"
          size="small"
          class="long"
          :options="provinceAndCityData"
          :props="{ checkStrictly: true }"
          v-model="model.area"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item
        label="部门"
        prop="departments"
        v-if="auth.isPlatformUser()"
      >
        <el-select
          style="width: 100%"
          v-model="model.departments"
          multiple
          placeholder="请选择部门"
        >
          <el-option
            v-for="(value, index) in DepartmentCategoryMap"
            :key="index"
            :label="value"
            :value="parseInt(index)"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item
        label="销售组"
        prop="group_id"
        v-if="!auth.isPlatformUser()"
      >
        <el-select
          style="width: 100%"
          v-model="model.group_id"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in groups"
            :key="item.id"
            :label="item.name"
            :value="parseInt(item.id)"
          ></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { groupList, createUser, updateUser, roleList } from '@/service/getData'
import auth from '@/util/auth'
import { AreaTextMap, DepartmentCategoryMap } from '@/config/global'
import { FunctionalRoles } from '../../config/global'
import { provinceAndCityData } from '@/util/area_tool'
import { clone } from '@/util'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  computed: {
    saleRoles() {
      let ids = []
      for (let i = 0; i < this.roles.length; i++) {
        const role = this.roles[i]
        if (
          role.name == FunctionalRoles.Sale ||
          role.name == FunctionalRoles.Telesale ||
          role.name == FunctionalRoles.NewProductSale
        ) {
          ids.push(role.id)
        }
      }
      return ids
    },
    rules() {
      let areaRule = false
      let selectdIDs = this.model.roles
      if (selectdIDs && this.saleRoles && this.saleRoles.length > 0) {
        let that = this
        let arr = selectdIDs.filter(function (v) {
          return that.saleRoles.indexOf(v) > -1
        })
        areaRule = arr.length > 0
      }

      return {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          {
            min: 2,
            max: 15,
            message: '长度在 2 到 15 个字符',
            trigger: 'blur',
          },
        ],
        area_id: [
          { required: areaRule, message: '请选择区域', trigger: 'change' },
        ],
        departments: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个部门',
            trigger: 'change',
          },
        ],
        roles: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个角色',
            trigger: 'change',
          },
        ],
        phone_number: [
          {
            required: true,
            pattern: /^1\d{10}$/,
            message: '手机号错误',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  data() {
    return {
      provinceAndCityData,
      auth,
      AreaTextMap,
      DepartmentCategoryMap,
      visible: this.show,
      groups: [],
      roles: [],
    }
  },
  created() {
    this.getRoles()
    if (!auth.isPlatformUser()) {
      this.getGroups()
    }
  },
  methods: {
    async getGroups() {
      let res = await groupList({ page: 0, size: 20000 })
      if (res.code == 0) {
        this.groups = res.data.list
      }
    },

    async getRoles() {
      let res = await roleList()
      if (res.code == 0) {
        this.roles = res.data.list.filter((item) => item.status == 1)
      }
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = clone(this.model)
          if (data.group_id == '') {
            data.group_id = 0
          }

          if (data.area_id == '') {
            data.area_id = 0
          }

          let area = data.area
          data.province = area[0] || ''
          data.city = area[1] || ''

          if (data.id > 0) {
            data.province = data.province || 'empty'
            data.city = data.city || 'empty'
            let res = await updateUser(data)
            if (res.code == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await createUser(data)
            if (res.code == 0) {
              this.$emit('created', res.data)
            }
          }

          this.visible = false
        } else {
          return false
        }
      })
    },
  },
}
</script>